export default "__VITE_PUBLIC_ASSET__a27d1d1b__"